import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import { baseurl } from "../utility/helper";
import "../assets/css/BatchPage.css";

// One-page flow: pick an institute -> pick one of its open tests -> continue to the
// existing institute registration/payment page (InsViewTest).

const InstituteTests = () => {
  const navigate = useNavigate();
  const [institutes, setInstitutes] = useState([]);
  const [selected, setSelected] = useState(null);
  const [tests, setTests] = useState([]);
  const studenttype = "institutestudent";
  const [loading, setLoading] = useState(true);
  const [testsLoading, setTestsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${baseurl}/institutes`)
      .then((r) => setInstitutes(r.data))
      .catch(() => setError("Could not load institutes. Please try again later."))
      .finally(() => setLoading(false));
  }, []);

  const selectInstitute = (inst) => {
    setSelected(inst);
    setTests([]);
    setError("");
    setTestsLoading(true);
    axios
      .get(`${baseurl}/institutes/${inst.institute_id}/tests`)
      .then((r) => setTests(r.data.tests))
      .catch(() => setError("Could not load tests. Please try again later."))
      .finally(() => setTestsLoading(false));
  };

  const blockedReason = (t) => {
    const now = dayjs();
    if (t.register_start_date && now.isBefore(dayjs(t.register_start_date))) return "Registration not open yet";
    if (t.register_end_date && now.isAfter(dayjs(t.register_end_date))) return "Registration closed";
    if (t.seat && t.registered_count >= t.seat) return "Seats full";
    return "";
  };

  const payForTest = (testId) =>
    navigate(`/InsViewTest?testId=${testId}&studenttype=${studenttype}`);

  return (
    <div className="batch-page">
      <div className="container">
        <div className="batch-head">
          <h1>Institute Tests</h1>
          <div className="batch-sub">
            {selected ? "Step 2 of 2: choose a test and pay" : "Step 1 of 2: choose your institute"}
          </div>
        </div>

        {error && <p className="batch-msg">{error}</p>}

        {!selected ? (
          loading ? (
            <p className="batch-msg">Loading…</p>
          ) : institutes.length === 0 && !error ? (
            <p className="batch-msg">No institutes have open tests right now.</p>
          ) : (
            <div className="row">
              {institutes.map((i) => (
                <div key={i.institute_id} className="col-lg-4 col-md-6 col-12 mt-4">
                  <div className="batch-test-card">
                    <h5>{i.name}</h5>
                    <div className="batch-sub">{i.location}</div>
                    <p className="text-muted mt-2 mb-3">
                      {i.test_count} open test{i.test_count === 1 ? "" : "s"}
                    </p>
                    <button className="btn btn-primary w-100" onClick={() => selectInstitute(i)}>
                      Select
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )
        ) : (
          <>
            <div className="batch-name text-center">
              {selected.name} <span>({selected.location})</span>
            </div>
            <div className="text-start mt-2">
              <button className="btn btn-outline-primary btn-sm" onClick={() => { setSelected(null); setTests([]); setError(""); }}>
                <b>← Change institute</b>
              </button>
            </div>

            {testsLoading ? (
              <p className="batch-msg">Loading…</p>
            ) : tests.length === 0 && !error ? (
              <p className="batch-msg">No tests are open for this institute yet.</p>
            ) : (
              <div className="row">
                {tests.map((t) => {
                  const blocked = blockedReason(t);
                  return (
                    <div key={t.test_id} className="col-lg-4 col-md-6 col-12 mt-4">
                      <div className="batch-test-card">
                        <h5>{t.test_title}</h5>
                        <div className="batch-sub">{t.batch_name} ({t.batch_code})</div>
                        <p className="mt-2 mb-1">
                          <b>{t.test_start_time ? dayjs(t.test_start_time).format("dddd, Do MMMM, YYYY") : "—"}</b>
                        </p>
                        <p className="text-muted">
                          {t.test_desc}
                          <br />
                          {t.venue}
                        </p>
                        {blocked ? (
                          <div className="batch-blocked">{blocked}</div>
                        ) : (
                          <button className="btn btn-primary w-100" onClick={() => payForTest(t.test_id)}>
                            Register &amp; Pay
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InstituteTests;
